import { Confetti } from "@today/ui/components/Confetti"
import { Button } from "baseui/button"
import { useRouter } from "next/router"
import { PropsWithChildren } from "react"
import { LoadingOverlay } from "../../common/LoadingOverlay"

type RegisteringOrSuccessProps = {
  companyName: string | undefined
  registerProcess: "isRegistering" | "registeredSuccessfully" | undefined
} & PropsWithChildren<{}>

function RegisteringOrSuccess({
  registerProcess,
  children,
  companyName,
}: RegisteringOrSuccessProps) {
  const router = useRouter()

  if (registerProcess === "isRegistering") {
    return (
      <div
        className="fixed left-0 top-0 h-screen w-screen"
        style={{ height: "100dvh" }}
      >
        <LoadingOverlay />
      </div>
    )
  }

  if (registerProcess === "registeredSuccessfully") {
    return (
      <>
        <div className="flex flex-1 flex-col items-center justify-center text-2xl">
          <p className="text-3xl">
            <span className="font-bold">{companyName}</span>님,
          </p>
          <p className="mt-2">가입이 완료되었습니다.</p>
          <Button className="my-12" onClick={() => router.replace("/orders")}>
            로그인 페이지로 이동하기
          </Button>
        </div>
        <Confetti />
      </>
    )
  }

  return <>{children}</>
}

export default RegisteringOrSuccess
